import axios from 'axios';

export const ActionBase = {
  
  getQsValue(param) {
    let qs = [];
    let reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
    for (let property in param) {
      let value = param[property];
      if (value != null) {
        if (Array.isArray(value)) {
          let arr = [];
          value.forEach(item => {
            arr.push(encodeURIComponent(item));
          });
          qs.push(property + '=' + arr);
        } else if (reg.test(value)) {
          qs.push(property + '=' + value);
        } else
          qs.push(property + '=' + encodeURIComponent(value));
      }
    }
    return qs.join('&');
  },

  requestAttachToken(context, url, type, param, okCb, config) {//前3个参数必传
    // console.log(param);
    return new Promise((resolve, reject) => {
      let configJson = {
        method: type,
        url: url,
        headers: { Authorization: "Bearer " + context.rootState.token },
      };
      if (config && config.login) {
        configJson.headers.Authorization = '';
      }
      if (config && config.blob) {
        configJson.responseType = 'blob'
      }
      if (type === 'GET') {
        (!configJson.url.includes('?')) && (configJson.url += '?');
        configJson.url += this.getQsValue(param)
      } else {
        if (!(config && config.encode)) {
          configJson.url = encodeURI(configJson.url);
        }
        configJson.data = param || {};
      }
      axios(configJson).then((response) => {
        if (typeof (okCb) === 'function')
          okCb(response);
        resolve(response)
      }, (error) => {
        reject(error.response)
      })
    })
  }
,
  request(context, type, url, param, config) {//公共方法
    return new Promise((resolve, reject) => {
      if (type === 'GET' || type === 'get') {
        url += this.getQsValue(param);
      } else {
        if (!(config && config.encode)) {
          url = encodeURI(url);
        }
      }
      axios({
        method: type,
        url: url,
        data: param,
      })
        .then((response) => {
          if (response.data.code && response.data.code === '3') {       //判断token过期跳转login页面
            window.location.href = window.location.href.split('#')[0] + '#/login';
            return;
          }
          resolve(response)
        }, (error) => { reject(error) })
    })
  },

};



// WEBPACK FOOTER //
// ./src/store/actionBase.js